export const products = [
  {
    id: '1',
    name: 'KONG Cat Wobbler Treat Dispensing Toy',
    price: 12.99,
    image: 'https://public.readdy.ai/ai/img_res/bb7fd8569255d55afa7e88ae9914767b.jpg',
    description: 'Interactive treat-dispensing toy that wobbles and rolls to keep cats engaged while rewarding them with treats.',
    category: 'Toys',
    inStock: true,
    rating: 4.5,
    reviews: 2847,
    link: 'https://www.chewy.com/kong-cat-wobbler-treat-dispensing-toy/dp/40020?clickId=7052767',
    retailer: 'chewy',
    badge: 'BESTSELLER',
    whyWeLoveIt: 'Slows down fast eaters while providing mental stimulation',
    features: [
      'Encourages healthy eating habits',
      'Reduces boredom and anxiety',
      'Easy to clean and fill',
      'Dishwasher safe'
    ]
  },
  {
    id: '2',
    name: 'SmartCat Ultimate Scratching Post',
    price: 89.99,
    originalPrice: 109.99,
    image: 'https://readdy.ai/api/search-image?query=Tall%20beige%20sisal%20rope%20cat%20scratching%20post%2036%20inches%20high%20with%20wide%20stable%20base%2C%20natural%20woven%20texture%2C%20minimalist%20modern%20pet%20furniture%20design%20on%20white%20background%20with%20soft%20studio%20lighting&width=400&height=400&seq=smartcat-post-v2&orientation=squarish',
    description: 'Tall, sturdy scratching post with natural sisal rope and plush base for maximum comfort and durability.',
    category: 'Furniture',
    inStock: true,
    rating: 4.7,
    reviews: 1523,
    link: 'https://www.chewy.com/smartcat-ultimate-32-in-sisal-cat/dp/49133?clickId=7052767',
    retailer: 'chewy',
    badge: 'TOP RATED',
    whyWeLoveIt: 'Perfect height for full-body stretching and scratching',
    features: [
      '36 inches tall',
      'Natural sisal rope',
      'Anti-tip base design',
      'Easy assembly'
    ]
  },
  {
    id: '3',
    name: 'Yeowww! Catnip Banana',
    price: 4.99,
    image: 'https://readdy.ai/api/search-image?query=Bright%20yellow%20fabric%20banana%20shaped%20cat%20toy%20filled%20with%20organic%20catnip%2C%20realistic%20banana%20texture%20with%20brown%20spots%2C%20fun%20playful%20pet%20toy%20on%20clean%20white%20background%2C%20product%20photography%20style&width=400&height=400&seq=yeowww-banana-v2&orientation=squarish',
    description: 'Premium organic catnip-filled banana toy that drives cats wild with excitement and provides hours of entertainment.',
    category: 'Toys',
    inStock: true,
    rating: 4.8,
    reviews: 5672,
    link: 'https://www.chewy.com/yeowww-catnip-yellow-banana-cat-toy/dp/130257?clickId=7052767',
    retailer: 'chewy',
    badge: 'BESTSELLER',
    whyWeLoveIt: 'Irresistible organic catnip that cats go absolutely crazy for',
    features: [
      '100% organic catnip',
      'Durable cotton fabric',
      'Perfect size for carrying',
      'Made in USA'
    ]
  },
  {
    id: '4',
    name: 'PetSafe Drinkwell Platinum Pet Fountain',
    price: 45.99,
    image: 'https://readdy.ai/api/search-image?query=White%20plastic%20cat%20water%20fountain%20with%20flowing%20stream%20and%20reservoir%2C%20modern%20automatic%20pet%20hydration%20system%20with%20visible%20water%20flow%2C%20clean%20product%20design%20on%20neutral%20background%20with%20professional%20lighting&width=400&height=400&seq=drinkwell-platinum-v2&orientation=squarish',
    description: 'Encourages hydration with fresh, filtered water flow. Quiet pump and easy-clean design.',
    category: 'Health',
    inStock: false,
    rating: 4.4,
    reviews: 892,
    link: 'https://www.chewy.com/petsafe-drinkwell-platinum-pet-fountain/dp/47324?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Keeps cats hydrated with fresh, filtered flowing water',
    features: [
      '2-liter capacity',
      'Replaceable carbon filter',
      'Dishwasher safe',
      'Ultra-quiet operation'
    ]
  },
  {
    id: '5',
    name: 'Go Cat Da Bird Wand Toy',
    price: 8.99,
    image: 'https://readdy.ai/api/search-image?query=Interactive%20cat%20wand%20toy%20with%20real%20guinea%20fowl%20feathers%20attached%20to%20flexible%20wire%20and%20telescopic%20handle%2C%20natural%20brown%20and%20white%20feathers%2C%20dynamic%20pet%20toy%20on%20clean%20white%20background&width=400&height=400&seq=da-bird-wand-v2&orientation=squarish',
    description: 'Interactive wand toy with real feathers that mimics bird flight patterns to trigger cats natural hunting instincts.',
    category: 'Toys',
    inStock: true,
    rating: 4.9,
    reviews: 3456,
    link: 'https://www.chewy.com/go-cat-da-bird-pull-apart-feather/dp/36072?clickId=7052767',
    retailer: 'chewy',
    badge: 'TOP RATED',
    whyWeLoveIt: 'Mimics real bird flight to trigger natural hunting instincts',
    features: [
      'Real guinea fowl feathers',
      'Telescopic wand extends to 3 feet',
      'Swivel connection prevents tangling',
      'Replacement feathers available'
    ]
  },
  {
    id: '6',
    name: 'Sherpa Original Deluxe Pet Carrier',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=Gray%20soft-sided%20pet%20carrier%20bag%20with%20mesh%20ventilation%20windows%20and%20padded%20shoulder%20strap%2C%20comfortable%20airline%20approved%20cat%20travel%20carrier%20on%20white%20background%2C%20professional%20pet%20product%20photography&width=400&height=400&seq=sherpa-carrier-v2&orientation=squarish',
    description: 'Comfortable and secure travel carrier with mesh windows for visibility and ventilation.',
    category: 'Travel',
    inStock: true,
    rating: 4.3,
    reviews: 1247,
    link: 'https://www.chewy.com/sherpa-original-deluxe-airline-approved/dp/47123?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Airline-approved design makes traveling with cats stress-free',
    features: [
      'Airline approved',
      'Mesh ventilation panels',
      'Comfortable shoulder strap',
      'Folds flat for storage'
    ]
  },
  {
    id: '7',
    name: 'Temptations Classic Treats Variety Pack',
    price: 15.99,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20pack%20of%20Temptations%20cat%20treats%20with%20multiple%20flavor%20pouches%20in%20red%20blue%20and%20green%20packaging%2C%20crunchy%20cat%20snacks%20with%20soft%20centers%2C%20appetizing%20pet%20treat%20product%20on%20clean%20background&width=400&height=400&seq=temptations-variety-v2&orientation=squarish',
    description: 'Irresistible crunchy treats with soft centers in multiple flavors that cats absolutely love.',
    category: 'Treats',
    inStock: true,
    rating: 4.6,
    reviews: 8923,
    link: 'https://www.chewy.com/temptations-classic-feline-favorites/dp/36073?clickId=7052767',
    retailer: 'chewy',
    badge: 'BESTSELLER',
    whyWeLoveIt: 'Cats literally shake with excitement when they hear the bag',
    features: [
      'Six different flavors',
      'Crunchy outside, soft inside',
      'Under 2 calories per treat',
      'No artificial fillers'
    ]
  },
  {
    id: '8',
    name: 'Litter-Robot 4 Automatic Self-Cleaning Litter Box',
    price: 699.99,
    originalPrice: 749.99,
    image: 'https://readdy.ai/api/search-image?query=Modern%20white%20and%20gray%20automatic%20self-cleaning%20cat%20litter%20box%20with%20spherical%20rotating%20design%20and%20app%20connectivity%2C%20futuristic%20smart%20pet%20technology%20with%20sleek%20curves%20on%20clean%20background&width=400&height=400&seq=litter-robot-4-v2&orientation=squarish',
    description: 'Self-cleaning smart litter box with app connectivity and odor control technology.',
    category: 'Litter',
    inStock: true,
    rating: 4.2,
    reviews: 567,
    link: 'https://www.chewy.com/whisker-litter-robot-4-cat-litter-box/dp/617606?clickId=7052767',
    retailer: 'chewy',
    badge: 'SALE',
    whyWeLoveIt: 'Never scoop litter again with this smart automation',
    features: [
      'Auto-cleaning cycle',
      'Smartphone app control',
      'Health monitoring',
      'Odor elimination system'
    ]
  },
  {
    id: '9',
    name: 'Inaba Churu Lickable Cat Treats',
    price: 19.99,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Inaba%20Churu%20cat%20treat%20tubes%20with%20colorful%20packaging%20showing%20tuna%20and%20chicken%20flavors%2C%20creamy%20lickable%20puree%20treats%20in%20squeezable%20tubes%2C%20premium%20pet%20snack%20product%20on%20white%20background&width=400&height=400&seq=churu-treats-v2&orientation=squarish',
    description: 'Creamy, lickable treats made with real chicken and tuna that cats find absolutely irresistible.',
    category: 'Treats',
    inStock: true,
    rating: 4.8,
    reviews: 4521,
    link: 'https://www.chewy.com/inaba-churu-tuna-chicken-puree/dp/184459?clickId=7052767',
    retailer: 'chewy',
    badge: 'TOP RATED',
    whyWeLoveIt: 'Cats literally lick these tubes clean every single time',
    features: [
      'Made with real chicken and tuna',
      'No grains, preservatives, or carrageenan',
      'Convenient squeeze tubes',
      '20 tubes per pack'
    ]
  },
  {
    id: '10',
    name: 'Blue Buffalo Wilderness High Protein Cat Food',
    price: 52.99,
    image: 'https://readdy.ai/api/search-image?query=Blue%20Buffalo%20Wilderness%20cat%20food%20bag%20with%20blue%20and%20brown%20packaging%20showing%20chicken%20recipe%2C%20grain-free%20high%20protein%20dry%20cat%20food%20with%20wilderness%20theme%20graphics%2C%20premium%20pet%20nutrition%20on%20clean%20background&width=400&height=400&seq=blue-wilderness-v2&orientation=squarish',
    description: 'High-protein, grain-free dry cat food inspired by the diet of wild cats with real chicken as the first ingredient.',
    category: 'Food',
    inStock: true,
    rating: 4.5,
    reviews: 3789,
    link: 'https://www.chewy.com/blue-buffalo-wilderness-adult-chicken/dp/36074?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Wild-inspired nutrition that cats naturally crave',
    features: [
      'Real chicken is the first ingredient',
      'Grain-free formula',
      'No chicken by-product meals',
      'Rich in antioxidants'
    ]
  },
  {
    id: '11',
    name: 'Purina Pro Plan Sensitive Skin & Stomach',
    price: 48.99,
    image: 'https://readdy.ai/api/search-image?query=Purina%20Pro%20Plan%20cat%20food%20bag%20with%20blue%20and%20white%20veterinary%20branding%2C%20indoor%20adult%20cat%20formula%20with%20chicken%20recipe%2C%20veterinary%20diet%20dry%20cat%20food%20with%20professional%20branding%20on%20clean%20background&width=400&height=400&seq=purina-sensitive-v2&orientation=squarish',
    description: 'Specialized formula with salmon as the first ingredient, designed for cats with sensitive skin and stomachs.',
    category: 'Food',
    inStock: true,
    rating: 4.4,
    reviews: 2156,
    link: 'https://www.chewy.com/purina-pro-plan-sensitive-skin-stomach/dp/36075?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Perfect for cats with food sensitivities and allergies',
    features: [
      'Salmon is the first ingredient',
      'Easily digestible rice and oat meal',
      'Omega-6 fatty acids for skin health',
      'Prebiotic fiber for digestive health'
    ]
  },
  {
    id: '12',
    name: 'Nina Ottosson Cat Puzzle Feeder',
    price: 24.99,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20interactive%20cat%20puzzle%20feeder%20bowl%20with%20multiple%20compartments%20and%20sliding%20pieces%20in%20bright%20colors%2C%20mental%20stimulation%20feeding%20toy%20with%20treat%20hiding%20spots%20on%20white%20background&width=400&height=400&seq=puzzle-feeder-v2&orientation=squarish',
    description: 'Slow-feeding puzzle bowl that challenges cats mentally while promoting healthy eating habits.',
    category: 'Feeding',
    inStock: true,
    rating: 4.6,
    reviews: 1834,
    link: 'https://www.chewy.com/nina-ottosson-by-outward-hound-cat/dp/136875?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Turns mealtime into a fun mental challenge',
    features: [
      'Promotes slower eating',
      'Mental stimulation',
      'Non-slip base',
      'Dishwasher safe'
    ]
  },
  {
    id: '13',
    name: 'Catit Flower Fountain',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=White%20flower-shaped%20cat%20water%20fountain%20with%20three%20yellow%20petal%20streams%2C%20modern%20Catit%20design%20with%20flowing%20water%20and%20LED%20light%2C%20elegant%20pet%20hydration%20product%20on%20clean%20background&width=400&height=400&seq=catit-flower-v2&orientation=squarish',
    description: 'Attractive flower-shaped water fountain that provides fresh, filtered water with multiple drinking areas.',
    category: 'Health',
    inStock: true,
    rating: 4.3,
    reviews: 2987,
    link: 'https://www.chewy.com/catit-flower-fountain/dp/36076?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Beautiful design that cats love and owners appreciate',
    features: [
      '3 different drinking areas',
      'Replaceable carbon filter',
      '3-liter capacity',
      'Compact design'
    ]
  },
  {
    id: '14',
    name: 'PetSafe ScoopFree Self-Cleaning Litter Box',
    price: 169.99,
    image: 'https://readdy.ai/api/search-image?query=PetSafe%20ScoopFree%20automatic%20self-cleaning%20litter%20box%20in%20white%20and%20blue%20with%20crystal%20litter%20tray%20and%20rake%20mechanism%2C%20modern%20pet%20hygiene%20technology%20on%20clean%20background&width=400&height=400&seq=scoopfree-v2&orientation=squarish',
    description: 'Automatic self-cleaning litter box that uses crystal litter to absorb moisture and eliminate odors.',
    category: 'Litter',
    inStock: true,
    rating: 4.1,
    reviews: 1456,
    link: 'https://www.chewy.com/petsafe-scoopfree-self-cleaning-litter/dp/36077?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Hands-free litter box maintenance for busy cat parents',
    features: [
      'Automatic rake system',
      'Crystal litter technology',
      'Health counter tracks usage',
      'Leak-proof tray'
    ]
  },
  {
    id: '15',
    name: 'Feliway Classic Calming Diffuser Kit',
    price: 21.99,
    image: 'https://readdy.ai/api/search-image?query=Feliway%20white%20plugin%20diffuser%20device%20with%20blue%20branding%20and%20refill%20bottle%2C%20cat%20pheromone%20calming%20product%20for%20anxiety%20relief%2C%20veterinary%20wellness%20product%20on%20clean%20background&width=400&height=400&seq=feliway-diffuser-v2&orientation=squarish',
    description: 'Plug-in diffuser that releases calming pheromones to help reduce stress and anxiety in cats.',
    category: 'Health',
    inStock: true,
    rating: 4.0,
    reviews: 876,
    link: 'https://www.chewy.com/feliway-classic-30-day-starter-kit/dp/57066?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Drug-free way to calm anxious cats naturally',
    features: [
      'Clinically proven pheromones',
      'Covers up to 700 sq ft',
      'Lasts 30 days',
      'Drug-free solution'
    ]
  },
  {
    id: '16',
    name: 'Frisco 72-in Multi-Level Cat Tree',
    price: 129.99,
    image: 'https://readdy.ai/api/search-image?query=Tall%20beige%20multi-level%20cat%20tree%20tower%2072%20inches%20high%20with%20sisal%20scratching%20posts%2C%20multiple%20platforms%2C%20cozy%20condos%20and%20hanging%20toys%2C%20modern%20cat%20furniture%20on%20white%20background&width=400&height=400&seq=frisco-tree-v2&orientation=squarish',
    description: 'Multi-level cat tree with scratching posts, perches, and hideaways for climbing, playing, and resting.',
    category: 'Furniture',
    inStock: true,
    rating: 4.5,
    reviews: 2341,
    link: 'https://www.chewy.com/frisco-72-in-faux-fur-cat-tree/dp/36078?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Perfect cat playground that saves your furniture',
    features: [
      '72 inches tall',
      'Multiple scratching surfaces',
      'Cozy condos and perches',
      'Faux fur covering'
    ]
  },
  {
    id: '17',
    name: 'K&H Thermo-Kitty Heated Cat Bed',
    price: 39.99,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20round%20heated%20cat%20bed%20with%20soft%20plush%20sage%20green%20fabric%20and%20raised%20edges%2C%20thermostatically%20controlled%20warming%20pet%20bed%20with%20comfortable%20cushion%20on%20white%20background&width=400&height=400&seq=heated-bed-v2&orientation=squarish',
    description: 'Thermostatically controlled heated bed that provides warmth and comfort for cats, especially seniors.',
    category: 'Bedding',
    inStock: true,
    rating: 4.7,
    reviews: 1923,
    link: 'https://www.chewy.com/kh-thermo-kitty-heated-cat-bed/dp/36079?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Senior cats and cold weather cats absolutely love this warmth',
    features: [
      'Thermostat controlled',
      'MET safety listed',
      'Removable washable cover',
      'Available in multiple sizes'
    ]
  },
  {
    id: '18',
    name: 'One Fast Cat Exercise Wheel',
    price: 289.99,
    image: 'https://readdy.ai/api/search-image?query=Large%20gray%20cat%20exercise%20wheel%2048%20inches%20diameter%20with%20running%20track%20surface%2C%20modern%20pet%20fitness%20equipment%20for%20active%20cats%20on%20clean%20white%20background&width=400&height=400&seq=exercise-wheel-v2&orientation=squarish',
    description: 'Large exercise wheel designed for active cats to run, providing physical exercise and mental stimulation.',
    category: 'Exercise',
    inStock: false,
    rating: 4.3,
    reviews: 234,
    link: 'https://www.chewy.com/one-fast-cat-exercise-wheel/dp/178654?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Perfect for high-energy cats who need to burn calories',
    features: [
      '48-inch diameter',
      'Whisper-quiet operation',
      'Easy assembly',
      'Suitable for multiple cats'
    ]
  },
  {
    id: '19',
    name: 'Safari Self-Cleaning Slicker Brush',
    price: 12.99,
    image: 'https://readdy.ai/api/search-image?query=Cat%20grooming%20slicker%20brush%20with%20fine%20wire%20bristles%20and%20ergonomic%20blue%20handle%2C%20self-cleaning%20button%20mechanism%2C%20professional%20pet%20grooming%20tool%20on%20white%20background&width=400&height=400&seq=slicker-brush-v2&orientation=squarish',
    description: 'Professional-quality slicker brush with self-cleaning feature for removing loose fur and preventing matting.',
    category: 'Grooming',
    inStock: true,
    rating: 4.6,
    reviews: 1567,
    link: 'https://www.chewy.com/coastal-safari-cat-self-cleaning/dp/36080?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Makes brushing easy with the self-cleaning button',
    features: [
      'Self-cleaning button',
      'Fine wire bristles',
      'Ergonomic handle',
      'Reduces shedding'
    ]
  },
  {
    id: '20',
    name: 'Whistle Go Explore Health & Location Tracker',
    price: 79.99,
    image: 'https://readdy.ai/api/search-image?query=Bright%20orange%20GPS%20pet%20tracker%20device%20with%20clip%20attachment%2C%20modern%20health%20and%20location%20monitoring%20collar%20accessory%20for%20cats%2C%20high-tech%20pet%20safety%20product%20on%20white%20background&width=400&height=400&seq=whistle-tracker-v2&orientation=squarish',
    description: 'GPS tracking collar that helps locate cats in real-time with smartphone app integration.',
    category: 'Safety',
    inStock: true,
    rating: 4.2,
    reviews: 445,
    link: 'https://www.chewy.com/whistle-go-explore-dog-gps-tracker/dp/277142?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Peace of mind knowing you can always find your outdoor cat',
    features: [
      'Real-time GPS tracking',
      'Smartphone app',
      'Waterproof design',
      'Long battery life'
    ]
  },
  {
    id: '21',
    name: "Vet's Best Ear Relief Wash",
    price: 8.99,
    image: 'https://readdy.ai/api/search-image?query=Vets%20Best%20ear%20cleaning%20solution%20bottle%20with%20green%20and%20white%20veterinary%20branding%2C%20natural%20cat%20ear%20wash%20with%20applicator%20tip%2C%20professional%20pet%20health%20product%20on%20clean%20background&width=400&height=400&seq=ear-wash-v2&orientation=squarish',
    description: 'Natural ear cleaning solution that gently removes wax and debris while soothing irritated ears.',
    category: 'Health',
    inStock: true,
    rating: 4.4,
    reviews: 892,
    link: 'https://www.chewy.com/vets-best-ear-relief-wash-cats/dp/36081?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Gentle but effective ear cleaning that cats tolerate well',
    features: [
      'Natural ingredients',
      'Alcohol-free formula',
      'Easy-to-use applicator',
      'Veterinarian formulated'
    ]
  },
  {
    id: '22',
    name: 'Earthbath Hypo-Allergenic Cat Wipes',
    price: 6.99,
    image: 'https://readdy.ai/api/search-image?query=Earthbath%20hypoallergenic%20cat%20grooming%20wipes%20package%20with%20green%20natural%20branding%2C%20gentle%20pet%20cleaning%20wipes%20with%20aloe%20vera%2C%20eco-friendly%20pet%20hygiene%20product%20on%20white%20background&width=400&height=400&seq=cat-wipes-v2&orientation=squarish',
    description: 'Gentle, hypo-allergenic grooming wipes perfect for quick cleanups and maintaining coat health.',
    category: 'Grooming',
    inStock: true,
    rating: 4.5,
    reviews: 1234,
    link: 'https://www.chewy.com/earthbath-hypo-allergenic-cat-wipes/dp/36082?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Perfect for cats who hate baths but need cleaning',
    features: [
      'Hypo-allergenic formula',
      'Natural ingredients',
      '100 wipes per pack',
      'Safe for daily use'
    ]
  },
  {
    id: '23',
    name: 'TropiClean Waterless Cat Shampoo',
    price: 11.99,
    image: 'https://readdy.ai/api/search-image?query=TropiClean%20waterless%20cat%20shampoo%20foam%20bottle%20with%20tropical%20branding%20and%20coconut%20cleanser%2C%20no-rinse%20pet%20grooming%20product%20with%20pump%20dispenser%20on%20clean%20background&width=400&height=400&seq=waterless-shampoo-v2&orientation=squarish',
    description: 'Waterless foam shampoo that cleans and deodorizes without the stress of traditional bathing.',
    category: 'Grooming',
    inStock: true,
    rating: 4.3,
    reviews: 678,
    link: 'https://www.chewy.com/tropiclean-waterless-cat-shampoo-foam/dp/36083?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Clean cats without the drama of a bath',
    features: [
      'No rinsing required',
      'Natural coconut cleanser',
      'Reduces dander',
      'Pleasant tropical scent'
    ]
  },
  {
    id: '24',
    name: 'Catit PIXI Smart 6-Meal Feeder',
    price: 179.99,
    image: 'https://readdy.ai/api/search-image?query=Catit%20PIXI%20smart%20automatic%20cat%20feeder%20with%20white%20modern%20design%2C%20digital%20display%20showing%20meal%20times%2C%20six%20compartment%20rotating%20feeder%20with%20app%20control%20on%20clean%20background&width=400&height=400&seq=pixi-feeder-v2&orientation=squarish',
    description: 'Smart automatic feeder that dispenses up to 6 meals with smartphone app control and portion management.',
    category: 'Feeding',
    inStock: true,
    rating: 4.1,
    reviews: 567,
    link: 'https://www.chewy.com/catit-pixi-smart-6-meal-feeder/dp/36084?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Never worry about feeding schedules when traveling',
    features: [
      'Smartphone app control',
      'Portion control',
      '6 meal capacity',
      'Stainless steel bowls'
    ]
  },
  // NEW EXPANDED PRODUCTS START HERE
  {
    id: '25',
    name: 'SureFlap Microchip Pet Door',
    price: 149.99,
    image: 'https://readdy.ai/api/search-image?query=White%20electronic%20cat%20door%20with%20microchip%20scanner%20technology%2C%20modern%20SureFlap%20pet%20access%20control%20with%20transparent%20flap%20and%20battery%20compartment%2C%20smart%20home%20pet%20product%20on%20clean%20background&width=400&height=400&seq=sureflap-door-v2&orientation=squarish',
    description: 'Electronic pet door that only opens for your cats microchip, keeping unwanted animals out.',
    category: 'Safety',
    inStock: true,
    rating: 4.5,
    reviews: 1832,
    link: 'https://www.chewy.com/sureflap-microchip-small-dog-cat-door/dp/157129?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Selective entry keeps strays out while letting your cat roam free',
    features: [
      'Microchip recognition technology',
      'Battery powered (up to 12 months)',
      'Weatherproof seal',
      'Manual 4-way lock'
    ]
  },
  {
    id: '26',
    name: 'Drinkwell 360 Stainless Steel Pet Fountain',
    price: 89.99,
    image: 'https://readdy.ai/api/search-image?query=Circular%20stainless%20steel%20cat%20water%20fountain%20with%20360%20degree%20design%20and%20multiple%20water%20streams%2C%20premium%20PetSafe%20Drinkwell%20fountain%20with%20center%20tower%20on%20white%20background&width=400&height=400&seq=drinkwell-360-v2&orientation=squarish',
    description: '360-degree design provides fresh, filtered water from multiple angles to accommodate multiple pets.',
    category: 'Health',
    inStock: true,
    rating: 4.4,
    reviews: 2156,
    link: 'https://www.chewy.com/petsafe-drinkwell-360-stainless-steel/dp/48105?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Stainless steel is hygienic and dishwasher safe',
    features: [
      '128 oz capacity',
      'Stainless steel construction',
      'Adjustable water flow',
      'Dishwasher safe'
    ]
  },
  {
    id: '27',
    name: 'Bergan Turbo Scratcher Cat Toy',
    price: 16.99,
    image: 'https://readdy.ai/api/search-image?query=Circular%20Bergan%20Turbo%20Scratcher%20with%20ball%20track%20around%20corrugated%20cardboard%20center%2C%20interactive%20cat%20toy%20with%20rolling%20ball%20and%20scratching%20surface%20in%20gray%20and%20orange%20colors%20on%20white%20background&width=400&height=400&seq=turbo-scratcher-v2&orientation=squarish',
    description: 'Circular scratcher with spinning ball that provides scratching surface and interactive play.',
    category: 'Toys',
    inStock: true,
    rating: 4.6,
    reviews: 3421,
    link: 'https://www.chewy.com/bergan-turbo-scratcher-cat-toy/dp/49191?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Combines scratching and play in one irresistible package',
    features: [
      'Corrugated cardboard scratcher',
      'Ball bearing track system',
      'Non-slip base',
      'Replacement pads available'
    ]
  },
  {
    id: '28',
    name: "Hill's Science Diet Indoor Cat Food",
    price: 44.99,
    image: 'https://readdy.ai/api/search-image?query=Hills%20Science%20Diet%20cat%20food%20bag%20with%20blue%20and%20white%20veterinary%20branding%2C%20indoor%20adult%20cat%20formula%20with%20chicken%20recipe%2C%20premium%20pet%20nutrition%20with%20professional%20packaging%20on%20clean%20background&width=400&height=400&seq=hills-indoor-v2&orientation=squarish',
    description: 'Veterinary recommended nutrition specially formulated for adult indoor cats with controlled calories.',
    category: 'Food',
    inStock: true,
    rating: 4.5,
    reviews: 5234,
    link: 'https://www.chewy.com/hills-science-diet-adult-indoor-cat/dp/47852?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Trusted by veterinarians worldwide for indoor cat nutrition',
    features: [
      'Controlled calorie content',
      'Natural fiber for hairball control',
      'High-quality protein',
      'Clinically proven nutrition'
    ]
  },
  {
    id: '29',
    name: 'Petmate Booda Clean Step Litter Box',
    price: 24.99,
    image: 'https://readdy.ai/api/search-image?query=Petmate%20Booda%20dome%20litter%20box%20with%20built-in%20steps%20and%20hooded%20design%20in%20titanium%20color%2C%20modern%20cat%20litter%20box%20with%20ventilation%20and%20step%20platform%20on%20white%20background&width=400&height=400&seq=booda-cleanstep-v2&orientation=squarish',
    description: 'Hooded litter box with built-in steps that help reduce litter tracking throughout your home.',
    category: 'Litter',
    inStock: true,
    rating: 4.2,
    reviews: 1876,
    link: 'https://www.chewy.com/petmate-booda-dome-cleanstep-litter/dp/47634?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Steps catch litter before it spreads around your house',
    features: [
      'Built-in litter catching steps',
      'Removable hood',
      'Easy-clean surface',
      'Reduces tracking by 50%'
    ]
  },
  {
    id: '30',
    name: 'FURminator deShedding Tool for Cats',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=FURminator%20deshedding%20brush%20with%20yellow%20and%20gray%20ergonomic%20handle%20and%20stainless%20steel%20edge%2C%20professional%20cat%20grooming%20tool%20for%20removing%20loose%20undercoat%20fur%20on%20white%20background&width=400&height=400&seq=furminator-v2&orientation=squarish',
    description: 'Professional-grade deshedding tool that reduces shedding by up to 90% when used regularly.',
    category: 'Grooming',
    inStock: true,
    rating: 4.7,
    reviews: 4521,
    link: 'https://www.chewy.com/furminator-deshedding-tool-cats/dp/47965?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Dramatically reduces shedding and prevents matting',
    features: [
      'Reduces shedding up to 90%',
      'Stainless steel edge',
      'Ergonomic handle',
      'Suitable for all coat lengths'
    ]
  },
  {
    id: '31',
    name: 'SmartCat Peek-a-Prize Toy Box',
    price: 22.99,
    image: 'https://readdy.ai/api/search-image?query=Wooden%20puzzle%20box%20cat%20toy%20with%20multiple%20circular%20holes%20and%20colorful%20balls%20inside%2C%20SmartCat%20interactive%20enrichment%20toy%20in%20natural%20wood%20finish%20on%20white%20background&width=400&height=400&seq=peek-prize-v2&orientation=squarish',
    description: 'Interactive puzzle box with multiple openings that challenges cats to retrieve hidden toys and treats.',
    category: 'Toys',
    inStock: true,
    rating: 4.4,
    reviews: 1598,
    link: 'https://www.chewy.com/smartcat-peek-prize-toy-box/dp/47823?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Keeps intelligent cats engaged for hours of mental stimulation',
    features: [
      'Multiple peek holes',
      'Durable wood construction',
      'Includes 3 balls',
      'Encourages natural hunting behavior'
    ]
  },
  {
    id: '32',
    name: 'Pet Gear I-GO2 Roller Backpack',
    price: 89.99,
    image: 'https://readdy.ai/api/search-image?query=Navy%20blue%20rolling%20pet%20carrier%20backpack%20with%20telescoping%20handle%20and%20wheels%2C%20convertible%20cat%20travel%20bag%20with%20mesh%20windows%20and%20multiple%20carrying%20options%20on%20white%20background&width=400&height=400&seq=igo2-roller-v2&orientation=squarish',
    description: 'Versatile pet carrier that converts from backpack to roller bag for easy travel with your cat.',
    category: 'Travel',
    inStock: true,
    rating: 4.3,
    reviews: 967,
    link: 'https://www.chewy.com/pet-gear-i-go2-roller-backpack/dp/47745?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Three carriers in one: backpack, roller, and car seat',
    features: [
      'Converts to backpack or roller',
      'Airline approved size',
      'Telescoping handle',
      'Multiple ventilation panels'
    ]
  },
  {
    id: '33',
    name: 'Wellness CORE Grain-Free Indoor Cat Food',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=Wellness%20CORE%20cat%20food%20bag%20with%20red%20and%20white%20branding%2C%20grain-free%20indoor%20formula%20with%20turkey%20and%20chicken%2C%20high-protein%20premium%20pet%20nutrition%20on%20clean%20background&width=400&height=400&seq=wellness-core-v2&orientation=squarish',
    description: 'High-protein, grain-free nutrition with deboned turkey and chicken for active indoor cats.',
    category: 'Food',
    inStock: true,
    rating: 4.6,
    reviews: 3456,
    link: 'https://www.chewy.com/wellness-core-grain-free-indoor/dp/47912?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Protein-packed nutrition that satisfies natural carnivore cravings',
    features: [
      'Grain-free, high-protein formula',
      'Deboned turkey and chicken',
      'Supports lean muscle mass',
      'Made in USA'
    ]
  },
  {
    id: '34',
    name: 'PetSafe Healthy Pet Simply Feed Automatic Feeder',
    price: 79.99,
    image: 'https://readdy.ai/api/search-image?query=White%20PetSafe%20automatic%20pet%20feeder%20with%20digital%20LCD%20display%20and%20programmable%20controls%2C%20modern%20pet%20feeding%20device%20with%20food%20hopper%20and%20stainless%20steel%20bowl%20on%20clean%20background&width=400&height=400&seq=simply-feed-v2&orientation=squarish',
    description: 'Programmable automatic feeder that dispenses scheduled meals to maintain your cats feeding routine.',
    category: 'Feeding',
    inStock: true,
    rating: 4.2,
    reviews: 2134,
    link: 'https://www.chewy.com/petsafe-healthy-pet-simply-feed/dp/47834?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Maintains feeding schedules even when youre away',
    features: [
      'Programmable meal times',
      'Portion control (1/8 to 4 cups)',
      'Battery backup',
      'Slow feed option'
    ]
  },
  {
    id: '35',
    name: 'Arm & Hammer Clump & Seal Multi-Cat Litter',
    price: 18.99,
    image: 'https://readdy.ai/api/search-image?query=Arm%20and%20Hammer%20Clump%20and%20Seal%20cat%20litter%20box%20with%20orange%20and%20white%20branding%2C%20multi-cat%20clumping%20litter%20with%20odor%20control%20technology%2C%20premium%20pet%20hygiene%20product%20on%20clean%20background&width=400&height=400&seq=clump-seal-v2&orientation=squarish',
    description: 'Powerful clumping litter with odor eliminators that seals and destroys odors on contact.',
    category: 'Litter',
    inStock: true,
    rating: 4.4,
    reviews: 6789,
    link: 'https://www.chewy.com/arm-hammer-clump-seal-multi-cat/dp/47756?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Superior odor control that actually works for multi-cat homes',
    features: [
      '7-day odor control',
      'Plant-derived particles',
      '99% dust-free',
      'Rock-hard clumps'
    ]
  },
  {
    id: '36',
    name: 'Cozy Cat Furniture Protector Panels',
    price: 32.99,
    image: 'https://readdy.ai/api/search-image?query=Clear%20transparent%20furniture%20protection%20panels%20for%20cats%20with%20adhesive%20backing%2C%20flexible%20scratch%20guard%20sheets%20for%20sofas%20and%20chairs%2C%20home%20protection%20product%20on%20white%20background&width=400&height=400&seq=furniture-protector-v2&orientation=squarish',
    description: 'Transparent furniture protectors that prevent cat scratching while maintaining your decors appearance.',
    category: 'Furniture',
    inStock: true,
    rating: 4.1,
    reviews: 1245,
    link: 'https://www.chewy.com/cozy-cat-furniture-protector-panels/dp/47867?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Protects furniture without changing your home aesthetics',
    features: [
      'Crystal clear material',
      'Easy peel-and-stick application',
      'Flexible to fit curves',
      'Removable without residue'
    ]
  },
  {
    id: '37',
    name: 'Thermos Stainless Steel Cat Bowl Set',
    price: 25.99,
    image: 'https://readdy.ai/api/search-image?query=Set%20of%20two%20stainless%20steel%20cat%20food%20and%20water%20bowls%20with%20non-slip%20rubber%20base%2C%20whisker-friendly%20wide%20shallow%20design%2C%20premium%20pet%20feeding%20dishes%20on%20white%20background&width=400&height=400&seq=steel-bowls-v2&orientation=squarish',
    description: 'Hygienic stainless steel bowl set with non-slip base that resists bacteria and is dishwasher safe.',
    category: 'Feeding',
    inStock: true,
    rating: 4.6,
    reviews: 2876,
    link: 'https://www.chewy.com/loving-pets-stainless-steel-cat-bowl/dp/47789?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Hygienic stainless steel that cats prefer over plastic',
    features: [
      'Bacteria-resistant surface',
      'Non-slip rubber base',
      'Dishwasher safe',
      'Whisker-friendly wide design'
    ]
  },
  {
    id: '38',
    name: 'Jackson Galaxy Air Wand Cat Toy',
    price: 14.99,
    image: 'https://readdy.ai/api/search-image?query=Jackson%20Galaxy%20interactive%20cat%20wand%20toy%20with%20colorful%20ribbons%20and%20feathers%2C%20air%20prey%20attachment%20with%20flowing%20streamers%2C%20professional%20cat%20behaviorist%20designed%20toy%20on%20white%20background&width=400&height=400&seq=galaxy-wand-v2&orientation=squarish',
    description: 'Interactive wand toy designed by cat behaviorist Jackson Galaxy to trigger hunting instincts.',
    category: 'Toys',
    inStock: true,
    rating: 4.5,
    reviews: 1987,
    link: 'https://www.chewy.com/jackson-galaxy-gotcha-interactive/dp/47923?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Designed by the famous cat behaviorist for maximum engagement',
    features: [
      'Designed by Jackson Galaxy',
      'Mimics flying prey',
      'Encourages natural hunting',
      'Replaceable attachments'
    ]
  },
  {
    id: '39',
    name: 'Sleepypod Air In-Cabin Pet Carrier',
    price: 159.99,
    image: 'https://readdy.ai/api/search-image?query=Premium%20Sleepypod%20Air%20soft-sided%20pet%20carrier%20in%20dark%20gray%20with%20mesh%20panels%2C%20luxury%20airline-approved%20cat%20travel%20bag%20with%20sherpa%20fleece%20interior%20on%20white%20background&width=400&height=400&seq=sleepypod-air-v2&orientation=squarish',
    description: 'Award-winning in-cabin pet carrier that exceeds airline requirements for comfort and safety.',
    category: 'Travel',
    inStock: true,
    rating: 4.8,
    reviews: 892,
    link: 'https://www.chewy.com/sleepypod-air-in-cabin-pet-carrier/dp/47845?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Award-winning design that makes flying with cats comfortable',
    features: [
      'Exceeds airline requirements',
      'Luxurious Sherpa fleece interior',
      'Structured base',
      'Mesh panels on 3 sides'
    ]
  },
  {
    id: '40',
    name: 'Merrick Purrfect Bistro Grain-Free Wet Food',
    price: 35.99,
    image: 'https://readdy.ai/api/search-image?query=Merrick%20Purrfect%20Bistro%20wet%20cat%20food%20variety%20pack%20with%20multiple%20gourmet%20flavor%20cans%2C%20grain-free%20premium%20pet%20nutrition%20with%20real%20meat%2C%20appetizing%20pet%20food%20packaging%20on%20clean%20background&width=400&height=400&seq=merrick-wet-v2&orientation=squarish',
    description: 'Grain-free wet food variety pack with real deboned meat as the first ingredient in gourmet flavors.',
    category: 'Food',
    inStock: true,
    rating: 4.7,
    reviews: 4123,
    link: 'https://www.chewy.com/merrick-purrfect-bistro-grain-free/dp/47901?clickId=7052767',
    retailer: 'chewy',
    whyWeLoveIt: 'Gourmet flavors that even picky cats absolutely devour',
    features: [
      'Real deboned meat first',
      'Grain-free recipe',
      '12 cans variety pack',
      'No artificial colors or preservatives'
    ]
  }
];

export const editorsPicks = {
  bestFood: [10, 11, 28, 33, 40, 7, 9],
  topToys: [5, 3, 1, 12, 27, 31, 38],
  groomingEssentials: [19, 22, 23, 21, 30],
  healthWellness: [13, 4, 15, 21, 26],
  furnitureComfort: [2, 16, 17, 36],
  travelSafety: [6, 20, 25, 32, 39],
  feedingSupplies: [12, 24, 34, 37],
  litterSolutions: [8, 14, 29, 35],
};
